import { useEffect, useRef } from 'react';

import { useApplication } from '@common/application';

const useChatbotCampaign = () => {
  const hasRunRef = useRef(false);
  const { searchParams } = useApplication();
  const isProd = process.env.NODE_ENV === 'production';

  useEffect(() => {
    const campaign = searchParams.get('topic');

    const hasRun = isProd ? false : hasRunRef.current;

    if (!hasRun && campaign) {
      window.seamly = window.seamly ?? [];
      window.seamly.push({ action: 'setVariables', args: { campaign } });
      window.seamly.push({
        action: 'setTopic',
        args: { name: 'campaign', fallbackMessage: 'Sorry, I cant help you right now' },
      });
      window.seamly.push({ action: 'setVisibility', args: 'open' });

      if (!isProd) {
        hasRunRef.current = true;
      }
    }
  }, [searchParams, isProd]);
};

export default useChatbotCampaign;
